import { toRaw } from 'vue';
import { jsBridgeSubjectInfoPromise, isAppEnv,
  hasDistributionPriceAuth as hasDistributionPriceAuthLib,
  hasPerm as hasPermLib,
  getSubjectInfo as getSubjectInfoLib,
  getMenuPermissions as getMenuPermissionsLib } from 'platform-lib-app';
import { useFinancial } from '@/store/modules/financial';
import { useUser } from '@/store/modules/user';
import { usePermission } from '@/store/modules/permission';
import { getMockMenu } from '../../apis/info/mock';

// 给财务使用的获取个人用户信息门店信息 由于财务有从建店助手跳入 如果与其他公用获取信息 有可能出现错乱的问题
export async function getSubjectInfoFinancial (params) {
  const userStore = useUser();
  const financialStore = useFinancial();
  if (!isAppEnv) {
    // mock data
    if (!financialStore.subjectInfo) {
      financialStore.subjectInfo = userStore.subjectInfo;
    }
    if (financialStore.headerShopMgCode) {
      financialStore.subjectInfo.subjectShop.mdCode = financialStore.headerShopMgCode;
    }
  }
  if (!financialStore.subjectInfo) {
    financialStore.subjectInfo = await jsBridgeSubjectInfoPromise();
  }
  if (financialStore.headerShopMgCode) {
    financialStore.subjectInfo.subjectShop.mdCode = financialStore.headerShopMgCode;
    if (financialStore.operationMode) {
      financialStore.subjectInfo.subjectShop.operationMode = financialStore.operationMode;
    }

    if (financialStore.shopName) {
      financialStore.subjectInfo.subjectShop.name = financialStore.shopName;
    }
  }
  return toRaw(financialStore.subjectInfo);
}

export async function getSubjectInfo (params) {
  return getSubjectInfoLib(params);
}
export async function getMenuPermissions (params) {
  return getMenuPermissionsLib(params);
}
// admin配置的权限标识符
export function hasPerm (code, prefix = 'franchise:partnerapp-operation:') {
  return hasPermLib(code, prefix);
}

// 获取敏感词查看权限
export function hasDistributionPriceAuth () {
  return hasDistributionPriceAuthLib();
}

export async function getRouterMenuPermissions (params) {
  if (!isAppEnv) {
    const res = getMockMenu();
    return res;
  }
  const permissionStore = usePermission();
  if (!permissionStore.routerPermissions) {
    permissionStore.routerPermissions = await jsBridgeGetMenuPerPromise();
  }
  return permissionStore.routerPermissions;
}
